import './IntentButton.css';
export var disabledAppIconOpacity = '_1xe9ern0-3-15-1';